import { FC } from 'react';

import { MultipleSelectFilter, PriceRangeFilter } from './index';
import { useEtimTranslation } from '../../../use/etim-translation';
import { currentPriceAttribute } from '../../../utils';

type GenericFilterProps = {
  attribute: string;
  sorterValue: number;
};

export const GenericFilter: FC<GenericFilterProps> = ({ attribute, sorterValue }) => {
  const { name, tooltip, unit } = useEtimTranslation(attribute);
  const opened = sorterValue <= 10;

  if (attribute.startsWith('price')) {
    return (
      <PriceRangeFilter
        key={currentPriceAttribute}
        title={theme.locales.price}
        attribute={currentPriceAttribute}
        opened={opened}
      />
    );
  }

  return (
    <MultipleSelectFilter
      key={`filter-${attribute}`}
      title={attribute === 'vendor' ? theme.locales.vendor : name}
      unit={unit}
      tooltip={tooltip}
      attribute={attribute}
      opened={opened}
    />
  );
};
